import { DatePickerProps } from 'antd';
import { Dayjs } from 'dayjs';
import { useCallback } from 'react';
import { DATE_FORMAT } from '../../utils';
import { DatePicker } from './DatePicker';
import { getPeriod, getDatePickerMode } from './utils';
import { Frequency } from '../../../dataobject';

export interface PeriodPickerProps
  extends Omit<DatePickerProps, 'value' | 'onChange' | 'picker'> {
  value?: Dayjs | null;
  onChange: (value: Dayjs | null) => void;
  frequency?: Frequency;
}

export function PeriodEndPicker({
  value,
  onChange,
  frequency,
  ...rest
}: PeriodPickerProps) {
  const format: DatePickerProps['format'] = useCallback(
    (value: Dayjs) => getPeriod(value, frequency)[1]?.format(DATE_FORMAT) || '',
    [frequency],
  );
  const handleChange = useCallback(
    (date: Dayjs | null) => {
      onChange(getPeriod(date, frequency)[1]);
    },
    [frequency, onChange],
  );

  return (
    <DatePicker
      allowClear={false}
      {...rest}
      value={value}
      picker={getDatePickerMode(frequency)}
      onChange={handleChange}
      format={format}
      style={{ width: '100%' }}
    />
  );
}
